import { useLayoutEffect, useState } from 'react';

/**
 * FadeStep — CSS-only crossfade-in keyed on mount (no framer-motion, which is
 * deliberately kept out of the cold-start login bundle). Remount this on a
 * step/key change so the incoming content fades up while a wrapping
 * AutoHeight tweens the container height — the two layers read as one morph.
 * Instant under prefers-reduced-motion.
 *
 * Shared across every settings MFA step-swap (enrollment's setup→add→code→
 * generating morph, the disable-2FA confirm toggle, the recovery-code
 * regenerate confirm toggle) so all three read as one consistent language.
 */
export default function FadeStep({ reduceMotion, children }) {
  const [shown, setShown] = useState(false);
  useLayoutEffect(() => {
    if (reduceMotion) {
      setShown(true);
      return undefined;
    }
    const t = window.setTimeout(() => setShown(true), 0);
    return () => window.clearTimeout(t);
  }, [reduceMotion]);
  return (
    <div
      style={
        reduceMotion
          ? undefined
          : {
              opacity: shown ? 1 : 0,
              transform: shown ? 'translateY(0)' : 'translateY(4px)',
              transition:
                'opacity 220ms cubic-bezier(0.16, 1, 0.3, 1), transform 220ms cubic-bezier(0.16, 1, 0.3, 1)',
            }
      }
    >
      {children}
    </div>
  );
}
